module.exports = __webpack_public_path__ + "static/media/new-york-fashion-academy.81020cbf.svg";